module.exports = __webpack_public_path__ + "static/media/playicons.46969589.svg";